const PropTypes = require('prop-types');
// @vendors
const React = require('react');
const {
    Component
} = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');
const { formatText, FormattedText } = require('core/i18n').i18n;
const trim = require('lodash/string/trim');

// @commons
const { OKCover } = require('commonsComponents/OKCover');
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const { OKButton } = require('commonsComponents/OKButton');
const OKBadge = require('components/commons/OKBadge/OKBadge');

// @components
const BrokerStocksHeader = require('components/broker/brokerProductHeaders/brokerStocksHeader/brokerStocksHeader');
const BrokerStocksBuyStep1 = require('components/broker/brokerStocksBuy/brokerStocksBuyStep1/brokerStocksBuyStep1');
const {
    BrokerStocksBuyStep2
} = require('components/broker/brokerStocksBuy/brokerStocksBuyStep2/brokerStocksBuyStep2');
const BrokerStocksBuySuccess = require('components/broker/brokerStocksBuy/brokerStocksBuySuccess/brokerStocksBuySuccess');
const BrokerTruncatedBreadcrumb = require('components/broker/brokerTruncatedBreadcrumb/brokerTruncatedBreadcrumb');
const { BrokerMiFIDBehavior } = require('mifid/components//brokerMiFIDBehavior/brokerMiFIDBehavior');
import FeatureTogglingRender from 'components/conditionalRender/featureTogglingRender';

// @actions
const BrokerStocksBuyActions = require('actions/brokerStocksBuy');
const ProductFileActions = require('actions/brokerGetProductFile.js');
const brokerProductsPossessionsActions = require('actions/brokerProductsPossessions');
const BrokerConvenienceMiFIDTestAction = require('mifid/actions/brokerConvenienceMiFIDTest');
const BrokerOpenTraderActions = require('actions/brokerOpenTrader');
const BrokerMyInvestmentsActions = require('actions/brokerMyInvestments');
const CollectivesCommissionsInfoAction = require('actions/collectivesCommissions');
const BlockedAccountsActions = require('actions/blockedAccounts');
const WebappRender = require('components/conditionalRender/webappRender')

const withFeatureToggling = require('hocs/withFeatureToggling/withFeatureToggling');

// @constants
const {
    FIRST_STEP,
    SECOND_STEP,
    COLLECTIVOS_STOCKS_BUY_LOCATION,
    SPANISH_CONTINUES_MARKET_ISO_CODE,
    HIRE_VALUES_CONTRACT_URL,
    MYPROFILE_BROKER_EXPLORE_URL,
    MYPROFILE_BROKER_URL,
    BROKER_CONVENIENCE_MIFID_TEST_STOCKS_ID,
    BROKER_CONVENIENCE_MIFID_STOCK,
    BROKER_CONVENIENCE_MIFID_STOCK_BUY,
    BROKER_MIFID_VERSION_2,
    BROKER_BUY_SCREEN,
    BROKER_INFO_SCREEN
} = require('constants/index');

const { ADVANCED_ORDER_SPANISH_STOCKS, OPENTRADER } = require('constants/flagBasedFeatures');
const { STOCKS_BUY_CODE } = require('constants/operationCodesAccounts');
const { catalogue, analyticsId } = require('components/broker/brokerStocksBuy/analytics/brokerStocksBuy.tracking');

class BrokerStocksBuyView extends Component {
    constructor(props) {
        super(props);

        this.checkMifid = true;

        this.buildWizard = this.buildWizard.bind(this);
        this.getProductDetails = this.getProductDetails.bind(this);
        this.buildSuccessful = this.buildSuccessful.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
    }

    componentWillMount() {
        const { immStocksContracts, history , match: { params: { isin }}} = this.props;

        this.props.getProductCatalogueDetails(isin);

        if (immStocksContracts.isEmpty()) {
            history.push(HIRE_VALUES_CONTRACT_URL);
        } else {
            this.handleMifid(this.props);
        }
    }

    componentDidMount() {
        const { immProfile, getBlockedAccounts, history, immAccounts } = this.props;

        this.getProductDetails();
        this.props.fetchMyInvestments();
        this.props.fetchOpenTraderLink();
        getBlockedAccounts(immAccounts.get('byId').toList(), STOCKS_BUY_CODE);

        if (immProfile.get('isCollective')) {
            this.props.getCollectivesCommissionsInfo(COLLECTIVOS_STOCKS_BUY_LOCATION, history);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (!nextProps.immStocksContracts.isEmpty()) {
            this.handleMifid(nextProps);
        }
    }

    componentWillUnmount() {
        this.props.reset();
        this.props.resetProduct();
        this.props.resetBlockedAccounts();
    }

    handleMifid(/*props*/) {
        /*if (!this.checkMifid) {
            return;
        }

        const productName = (props.productFile.get('companyName') || '').trim();

        if (!productName) {
            return;
        }

        const isin = props.params.isin;
        const iso = props.params.iso;

        const productUrl = `/myprofile/broker/productFile/${isin}/${iso}`;
        const productMifidId = BROKER_CONVENIENCE_MIFID_TEST_STOCKS_ID;
        const continuationUrl = `/myprofile/broker/stocksBuy/${isin}/${iso}`;

        props.onStartConvenienceMiFIDTest(
            productName,
            productUrl,
            productMifidId,
            continuationUrl,
            {
                hideAlreadyPerformTestResult: true,
                productType: BROKER_CONVENIENCE_MIFID_STOCK,
            }
        );

        this.checkMifid = false;*/
    }

    getProductDetails() {
        const {
            getProductDetails,
            getProductPossessions,
            match: { params: { isin, iso } },
            immBrokerConvenienceMiFIDTest
        } = this.props;
        const brokerScreen = immBrokerConvenienceMiFIDTest.get("started")
            ? BROKER_BUY_SCREEN
            : BROKER_INFO_SCREEN;
        getProductDetails(isin, iso, brokerScreen);
        getProductPossessions(isin, iso);
    }

    handleCancel() {
        this.props.history.push(MYPROFILE_BROKER_URL);
    }

    handleGoToAdvancedSearch() {
        this.props.history.push(MYPROFILE_BROKER_EXPLORE_URL);
    }

    buildWizard() {
        const {
            immBrokerWallets,
            immCollectivesCommissions,
            immProfile,
            immStocksBuy,
            immStocksContracts,
            immAccounts,
            productFile,
            match: { params },
            immMyInvestments,
            setHolidayError,
            flagBasedFeatures,
        } = this.props;
        const commisionsLinkUrlProc =  formatText('broker-product_buy_sale_flow_see_fees_link');
        const productIso = productFile.get('micCode');
        const productCurrency = productFile.get('currency');
        const productPrice = productFile.get('buyPrice');
        const immSteps = immStocksBuy.get('steps');
        const step1State = immSteps.get(0);
        const immErrorsStep1 = step1State.get('errors');
        const visibleStep = immStocksBuy.get('visibleStep');
        const firstStepLoading = immStocksBuy.getIn(['steps', FIRST_STEP, 'loading']);
        const secondStepLoading = immStocksBuy.getIn(['steps', SECOND_STEP, 'loading']);
        const isCollectiveUser = !!immProfile.get('isCollective');
        const actions = {
            setVisibleStep: this.props.setVisibleStep,
            setWillCancel: this.props.setWillCancel,
            finish: this.props.finish,
            validateStep: this.props.validateStep,
            cancel: this.handleCancel,
            updateStep1Form: this.props.updateStep1Form
        };
        const titleHeaderMenuWizard = visibleStep === 1 ? formatText('broker-stocksBuyViewWizardTitle') : formatText('broker-stocksBuyViewWizardTitleStepTwo');
        const headerMenuData = {
            title: titleHeaderMenuWizard,
            linksData: []
        };

        if (isCollectiveUser) {
            const commisionsLink = immCollectivesCommissions && immCollectivesCommissions.get('url');
            headerMenuData.extraContent = <OKBadge toUrl={commisionsLink} target={'_blank'} name={formatText('broker-stocksBuyWizardBadgeLabel').toUpperCase()} />;
        } else {
            headerMenuData.linksData.push({
                label: formatText('broker-commisions'),
                href: commisionsLinkUrlProc,
                hasTooltip: false,
                target: '_blank'
            });
        }

        if (flagBasedFeatures.get(ADVANCED_ORDER_SPANISH_STOCKS) && params.iso === SPANISH_CONTINUES_MARKET_ISO_CODE) {
            headerMenuData.linksData.unshift({
                label: formatText('broker-advancedOrder'),
                href: `/myprofile/broker/stocksAdvancedBuy/${params.isin}/${params.iso}`,
                hasTooltip: false
            });
        }
        const tealiumData = [
            catalogue[analyticsId.BROKER_STOCK_BUY_STEP_1_VIEW]({ productName: params.isin }),
            catalogue[analyticsId.BROKER_STOCK_BUY_STEP_2_VIEW]({ productName: params.isin }),
        ];
        const tealiumEvents = [
            catalogue[analyticsId.BROKER_STOCK_BUY_STEP_1_SUCCESS](),
        ];

        return (
            <Wizard
                wizardClass={'broker-stocks-buy__wizard'}
                actions={actions}
                immSteps={immSteps}
                stepsAmount={immSteps.size}
                visibleStep={visibleStep}
                hasHeaderMenu={true}
                headerMenuData={headerMenuData}
                tealium={tealiumData[visibleStep - 1]}
                tealiumEvents={{
                    next: tealiumEvents[visibleStep - 1],
                }}
                isTaggingSecondVersion
            >
                <WizardStep position="first" cancelButton={true} isLoading={firstStepLoading}>
                    <BrokerStocksBuyStep1
                        step1={step1State}
                        immBrokerWallets={immBrokerWallets}
                        errors={immErrorsStep1}
                        immStocksBuy={immStocksBuy}
                        immAccounts={immAccounts}
                        immStocksContracts={immStocksContracts}
                        resetStep1TitlesInput={this.props.resetStep1TitlesInput}
                        resetStep1ApproxImportInput={this.props.resetStep1ApproxImportInput}
                        resetStep1LimitedInput={this.props.resetStep1LimitedInput}
                        updateStep1Form={actions.updateStep1Form}
                        productIso={productIso}
                        productCurrency={productCurrency}
                        productPrice={productPrice}
                        immMyInvestments={immMyInvestments}
                        setHolidayError={setHolidayError}
                        productFile={productFile}
                        resetLotValuesByLot={this.props.resetLotValuesByLot}
                    />
                </WizardStep>
                <WizardStep
                    position="last"
                    immFinalButton="broker-stocksBuyViewFinishLabel"
                    cancelButton={true}
                    addLoadingBehaviour={true}
                    isLoading={secondStepLoading}>
                    <BrokerStocksBuyStep2
                        productFile={productFile}
                        immStocksContracts={immStocksContracts}
                        step1={step1State}
                        immFeatureFlags={flagBasedFeatures}
                    />
                </WizardStep>
            </Wizard>
        );
    }

    buildSuccessful() {
        const { immStocksContracts, productFile, immStocksBuy, match } = this.props;

        return (
            <BrokerStocksBuySuccess
                productFile={productFile}
                immStocksContracts={immStocksContracts}
                immStocksBuy={immStocksBuy}
                isin={match.params.isin}
            />
        );
    }

    getBreadcrumbData(productFile, isin, iso) {
        return [
            {
                text: formatText('breadcrumb-brokerInvestments'),
                url: MYPROFILE_BROKER_URL
            },
            {
                text: formatText('breadcrumb-brokerAdvancedSearch'),
                url: MYPROFILE_BROKER_EXPLORE_URL
            },
            {
                text: productFile.get('companyName'),
                url: `/myprofile/broker/productFile/${isin}/${iso}`
            },
            {
                text: formatText('breadcrumb-brokerStocksBuy'),
                url: ''
            }
        ];
    }

    render() {
        const { immStocksBuy, immMyInvestments, immOpenTrader, flagBasedFeatures, productFile, match: { params } } = this.props;
        const mappingBreadcrumb = this.getBreadcrumbData(productFile, params.isin, params.iso);
        const productName = trim(this.props.productFile.get('companyName'));
        const isin = this.props.match.params.isin;
        const iso = this.props.match.params.iso;
        const productUrl = `/myprofile/broker/productFile/${isin}/${iso}`;
        const continuationUrl = [
            `/myprofile/broker/stocksBuy/${isin}/${iso}`,
            `/myprofile/broker/stocksAdvancedBuy/${isin}/${iso}`
        ];
        const mifidOptions = {
            hideAlreadyPerformTestResult: true,
            productType: BROKER_CONVENIENCE_MIFID_STOCK,
            operationType: BROKER_CONVENIENCE_MIFID_STOCK_BUY,
        };

        let contractBoxContent;

        if (immStocksBuy.get('submitSuccessful')) {
            contractBoxContent = this.buildSuccessful();
        } else if (productFile.get('isinCode')) {
            contractBoxContent = this.buildWizard();
        }

        return (
            <BrokerMiFIDBehavior
                mifidVersion={BROKER_MIFID_VERSION_2}
                productName={productName}
                productUrl={productUrl}
                continuationUrl={continuationUrl}
                productIsinId={isin}
                productMarketId={iso}
                productMifidId={BROKER_CONVENIENCE_MIFID_TEST_STOCKS_ID}
                mifidOptions={mifidOptions}
            >
                <div>
                    <div className="container-fluid">
                        <div className="row">
                            <OKCover size="medium" section="broker" customClass="col-xs-12">
                                <BrokerTruncatedBreadcrumb
                                    titleKey="broker-stocksBuyViewTitle"
                                    breadcrumbConfig={mappingBreadcrumb}
                                    className="broker-stocks-buy-view__header">
                                    <OKButton inverse={true} modifier="ghost" onClick={() => this.handleGoToAdvancedSearch()}>
                                        <FormattedText format="firstUppercase" value="broker-goToAdvancedSearch" />
                                    </OKButton>
                                    <WebappRender>
                                        <FeatureTogglingRender notAllowedProductKey={OPENTRADER} >
                                            <OKButton inverse={true} modifier="primary" to={immOpenTrader.get('openTraderLink')}>
                                                <FormattedText format="firstUppercase" value="broker-openTraderLabel" />
                                            </OKButton>
                                        </FeatureTogglingRender>
                                    </WebappRender>
                                </BrokerTruncatedBreadcrumb>
                            </OKCover>
                        </div>
                    </div>
                    <div className="grid-view__body">
                        <div className="container-fluid">
                            <div className="row grid-view--content-position-negative">
                                <div className="col-xs-12">
                                    <BrokerStocksHeader
                                        productFile={productFile}
                                        immMyInvestments={immMyInvestments}
                                        handleUpdate={this.getProductDetails}
                                        noBottomButtons={true}
                                        immFlagBasedFeatures={flagBasedFeatures}
                                    />
                                </div>
                                <div className="col-xs-12 grid-view--fix-cell-separation">
                                    {contractBoxContent}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </BrokerMiFIDBehavior>
        );
    }
}

BrokerStocksBuyView.propTypes = {
    productFile: PropTypes.object,
    history: PropTypes.object.isRequired,
    immProfile: PropTypes.object,
    immStocksBuy: PropTypes.object,
    immAccounts: PropTypes.object,
    immBrokerWallets: PropTypes.object.isRequired,
    immStocksContracts: PropTypes.object,
    immMyInvestments: PropTypes.object.isRequired,
    immOpenTrader: PropTypes.object.isRequired,
    reset: PropTypes.func,
    resetBlockedAccounts: PropTypes.func,
    setVisibleStep: PropTypes.func,
    setWillCancel: PropTypes.func,
    finish: PropTypes.func,
    validateStep: PropTypes.func,
    getProductDetails: PropTypes.func,
    getProductPossessions: PropTypes.func,
    getBlockedAccounts: PropTypes.func.isRequired,
    resetProduct: PropTypes.func.isRequired,
    resetStep1TitlesInput: PropTypes.func,
    resetStep1ApproxImportInput: PropTypes.func,
    resetStep1LimitedInput: PropTypes.func,
    resetLotValuesByLot: PropTypes.func,
    updateStep1Form: PropTypes.func,
    step1FormState: PropTypes.object,
    match: PropTypes.object,
    onStartConvenienceMiFIDTest: PropTypes.func.isRequired,
    fetchOpenTraderLink: PropTypes.func.isRequired,
    fetchMyInvestments: PropTypes.func.isRequired,
    setHolidayError: PropTypes.func,
    getCollectivesCommissionsInfo: PropTypes.func,
    getProductCatalogueDetails: PropTypes.func,
    immCollectivesCommissions: PropTypes.object,
    flagBasedFeatures: PropTypes.object.isRequired,
    immBrokerConvenienceMiFIDTest: PropTypes.object.isRequired,
};

module.exports.constructor = BrokerStocksBuyView;
module.exports.BrokerStocksBuyView = connect(
    state => ({
        immBrokerWallets: state.brokerWallets,
        immAccounts: state.accounts,
        immCollectivesCommissions: state.collectivesCommissions,
        immMyInvestments: state.brokerMyInvestments,
        immOpenTrader: state.brokerOpenTrader,
        immProfile: state.profile,
        immStocksBuy: state.brokerStocksBuy,
        immStocksContracts: state.brokerStocksContract,
        productFile: state.brokerProductFile,
        flagBasedFeatures: state.flagBasedFeatures,
        immBrokerConvenienceMiFIDTest: state.brokerConvenienceMiFIDTest,
    }),
    {
        reset: BrokerStocksBuyActions.reset,
        resetBlockedAccounts: BlockedAccountsActions.resetBlockedAccounts,
        getBlockedAccounts: BlockedAccountsActions.getBlockedAccounts,
        setVisibleStep: BrokerStocksBuyActions.setVisibleStep,
        setWillLeave: BrokerStocksBuyActions.setWillLeave,
        setWillCancel: BrokerStocksBuyActions.setWillCancel,
        validateStep: BrokerStocksBuyActions.validateStep,
        finish: BrokerStocksBuyActions.finish,
        resetLotValuesByLot: BrokerStocksBuyActions.resetLotValuesByLot,
        getProductDetails: ProductFileActions.getProductFileWithCatalogData,
        getProductPossessions: brokerProductsPossessionsActions.getProductPossessions,
        resetProduct: ProductFileActions.reset,
        resetStep1TitlesInput: BrokerStocksBuyActions.resetStep1TitlesInput,
        resetStep1ApproxImportInput: BrokerStocksBuyActions.resetStep1ApproxImportInput,
        resetStep1LimitedInput: BrokerStocksBuyActions.resetStep1LimitedInput,
        updateStep1Form: BrokerStocksBuyActions.updateStep1Form,
        onStartConvenienceMiFIDTest: BrokerConvenienceMiFIDTestAction.start,
        fetchOpenTraderLink: BrokerOpenTraderActions.fetchLink,
        fetchMyInvestments: BrokerMyInvestmentsActions.fetchMyInvestments,
        setHolidayError: BrokerStocksBuyActions.setHolidayError,
        getCollectivesCommissionsInfo: CollectivesCommissionsInfoAction.getCollectivesCommissionsInfo,
        getProductCatalogueDetails: ProductFileActions.getStocksCatalogueDetails,

    }
)(withFeatureToggling(withRouter(BrokerStocksBuyView)));
